import React from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";

import css from "./CloneMenuForMenuComponent.module.css";
import {
    menuMenuActions,
    availableDishesActions,
} from "../../../store/slices/menu-slices";
import {availableDishesService} from "../../../services/menu-services/availableDishes.service";
import {menuMenuService} from "../../../services/menu-services/menuMenu.service";

const CloneMenuForMenuComponent = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {dataOfDay} = useSelector((store) => store.availableDishes);

    const {
        register,
        handleSubmit,
        formState: {errors, isSubmitting},
    } = useForm();

    const submit = async (data) => {
        if (!data?.date || !dataOfDay) return;

        if (data.date === dataOfDay) {
            toast.warning(t("Cannot clone menu from the same date"));
            return;
        }

        try {
            // 1. Get source menu
            const sourceMenu = await dispatch(menuMenuActions.getAllMenuPacks({currentData: data.date}));
            const menuPayload = sourceMenu.payload;

            if (!menuPayload || menuPayload.length === 0) {
                toast.warning(t("No menu found for the selected date"));
                return;
            }

            // 2. Get the current menu for the target date
            const currentMenu = await dispatch(menuMenuActions.getAllMenuPacks({currentData: dataOfDay}));
            const currentMenuItems = currentMenu.payload;

            // 3. Check if there are existing menu items for the target date
            if (currentMenuItems && currentMenuItems.length > 0) {
                // Confirm with user before overwriting
                if (!window.confirm(t("There is already a menu for this date. Do you want to overwrite it?"))) {
                    return; // User cancelled
                }

                // Delete existing menu items for target date
                try {
                    await menuMenuService.deleteByDate(dataOfDay);
                } catch (error) {
                    console.error("Error deleting existing menu items:", error);
                    toast.error(t("Error deleting existing menu"));
                    return;
                }
            }

            // 4. Clone available dishes
            await availableDishesService.cloneAvailableDishes({
                date: data.date,
                newDate: dataOfDay,
            });

            // console.log("availableDishesPayload", availableDishesPayload);
            // 4. Handle available dishes cloning
            // const sourceAvailable = await dispatch(
            //     availableDishesActions.getAllAvailableDishes({currentData: data.date})
            // );

            // if (sourceAvailable.payload?.length > 0) {
            //     const selectedData = sourceAvailable.payload.map((obj) => ({
            //         dishId: obj.dishId,
            //         date: dataOfDay,
            //     }));

            //     await availableDishesService.updateByDateOfDay(dataOfDay, selectedData);
            // }

            // 5. Create new menu items
            // for (const pack of menuPayload) {
            //     for (const menuDish of pack.menuDishes || []) {
            //         const result = await dispatch(menuMenuActions.createMenuPack({
            //             packId: pack.id,
            //             mealId: menuDish.mealId,
            //             dishId: menuDish.dish.id,
            //             date: dataOfDay,
            //         }));

            //         if (result.error) {
            //             throw new Error(result.error.message);
            //         }
            //     }
            // }

            // 6. Refresh the data
            await dispatch(menuMenuActions.getAllMenuPacks({currentData: dataOfDay}));
            dispatch(menuMenuActions.changeTrigger());
            dispatch(availableDishesActions.changeTrigger());

            toast.success(t("Menu and available dishes cloned successfully"));
        } catch (error) {
            console.error("Error cloning menu:", error);
            toast.error(t("Error cloning menu"));
        }
    };

    return (
        <section className={css.wrap}>
            <form onSubmit={handleSubmit(submit)} className={css.form}>
                <label className={css.label}>{t("Clone-menu-from")}</label>
                <input
                    type="date"
                    {...register("date", {required: "Date is required"})}
                    className={`${css.input} ${errors.date ? css.inputError : ""}`}
                />
                {errors.date && <p className={css.error}>{errors.date.message}</p>}
                <button type="submit" disabled={isSubmitting} className={css.button}>
                    {isSubmitting ? "Submitting..." : "Ok"}
                </button>
            </form>
        </section>
    );
};

export {CloneMenuForMenuComponent};

